'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pendingContentReactions;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function pendingReactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var reaction = action.payload.reaction;


  switch (action.type) {
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.REQUEST_REMOVE_REACTION:
      return [].concat(_toConsumableArray(state), [reaction]);
    case _actionTypes.FAIL_ADD_REACTION:
    case _actionTypes.SUCCESS_ADD_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
    case _actionTypes.SUCCESS_REMOVE_REACTION:
      var reactionIndex = state.lastIndexOf(reaction);
      if (reactionIndex === -1) {
        return state;
      }

      return [].concat(_toConsumableArray(state.slice(0, reactionIndex)), _toConsumableArray(state.slice(reactionIndex + 1)));
    default:
      return state;
  }
}

function pendingContentReactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.REQUEST_REMOVE_REACTION:
    case _actionTypes.FAIL_ADD_REACTION:
    case _actionTypes.SUCCESS_ADD_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
    case _actionTypes.SUCCESS_REMOVE_REACTION:
      var _action$payload = action.payload,
          communityContentRelatedId = _action$payload.communityContentRelatedId,
          communityContentType = _action$payload.communityContentType;

      var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;
      return Object.assign({}, state, _defineProperty({}, communityContentIdKey, pendingReactions(state[communityContentIdKey], action)));
    default:
      return state;
  }
}